import "../css/DashboardSummaryBox.css";
import ButtonIconH from "./ButtonIconH";

export function DashboardSummaryBox({ title, icon, text, style, onClick }) {
  return (
    <div className="db-box-content" style={style}>
      <span className="db-box-content-title">{title}</span>
      <div className="db-box-content-info">
        <img src={"/images/" + icon}></img>
        <span
          className="db-box-content-info-text"
          style={{ whiteSpace: "pre-line" }}
        >
          {text}
        </span>
      </div>
      <ButtonIconH
        text="Generar informe"
        small={true}
        onClick={onClick}
      ></ButtonIconH>
    </div>
  );
}
